/**
 * root.__runtime 共享读写器 — 消除 4 个文件各自重复的 file-local accessor。
 *
 * root.__runtime 是 prototype 桥接层挂在 DOM 根上的 mutable runtime 上下文
 * (PrototypeRuntime), 供 view 层模块在不 prop-drilling 的前提下共享 API 句柄、
 * 当前课程/章节、进度缓存等。本模块统一其读写入口与类型断言。
 */
import type { Root, PrototypeRuntime } from "./prototypeTypes";

const RUNTIME_KEY = "__runtime" as const;

/** 读取 root.__runtime(可能不存在 — mount 前或卸载后)。 */
export function getRuntime(root: Root): PrototypeRuntime | undefined {
	return (root as unknown as Record<string, unknown>)[RUNTIME_KEY] as PrototypeRuntime | undefined;
}

/** 写入 root.__runtime(PrototypeController mount 时 + mediaRouteHelpers 切换 target 时)。 */
export function setRuntime(root: Root, runtime: PrototypeRuntime): void {
	(root as unknown as Record<string, unknown>)[RUNTIME_KEY] = runtime;
}
